import React, { useContext, useState } from 'react';
import { defaultVehicleDataForm, VehicleDataForm } from '../../../app/models/Vehicle';
import useVehicleService from '../../../app/services/hooks/useVehicleService';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import VehicleFormContainer from './VehicleFormContainer';
import LazyLoading from '../../../components/LazyLoading';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';

interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const VehicleCreate = ({ onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const { fetchingStoreVehicle, storeVehicle } = useVehicleService();
    const [vehicle, setVehicle] = useState<VehicleDataForm>(defaultVehicleDataForm);
    const [errorFields, setErrorFields] = useState<any>();

    const store = () => {
        if (showLoading) showLoading('loading', 'Guardando vehículo...');
        storeVehicle(vehicle, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return (
        <VehicleFormContainer
            fetching={fetchingStoreVehicle}
            action={store}
            cancel={cancel}
            vehicle={vehicle}
            setVehicle={setVehicle}
            errorFields={errorFields}
        />
    );
};

export default VehicleCreate;
